module.exports = __webpack_public_path__ + "efdc8ed6332061e620714fb6edc38a66.png";